import React, { Component, createRef } from "react";
import { MasterPage, NumFuncionalidade } from "../MasterPage";
import { Alerta, Botao, Box, CampoEstatico, Col, Combo, Row, TipoAlerta, TipoBotao, TipoCampoEstatico } from "@intechprev/componentes-web";
import { FichaFinanceiraEntidade } from "../../entidades";
import { FichaFinanceiraService, PlanoService } from "../../services";
import { DMN_CATEGORIA } from "../../domains";

declare global {
  interface Navigator {
    msSaveBlob?: (blob: any, defaultName?: string) => boolean
  }
}

interface IProps { }

interface State {
  Error: string;
  Referencia: string;
  Datas: FichaFinanceiraEntidade[];
  Informe: any[];
}

export class DeclaracaoIR extends Component<IProps, State> {
  private page = createRef<MasterPage>();

  constructor(props: IProps) {
    super(props);

    this.state = {
      Error: "",
      Referencia: "",
      Datas: [],
      Informe: []
    }
  }

  componentDidMount = async () => {
    await this.page.current.alternarLoading();
    try {
      const categoriasIR = [DMN_CATEGORIA.AUTOPATROCINIO, DMN_CATEGORIA.DIFERIDO];
      const situacoesIR = ["43", "54"];

      const planos = await PlanoService.Buscar();

      if (planos.some(x => (categoriasIR.some(z => z === x.CD_CATEGORIA)) && (situacoesIR.some(z => z === x.CD_SIT_PLANO)))) {
        var datas = await FichaFinanceiraService.BuscarDatasInforme();
        this.setState({
          Referencia: datas.length > 0 ? datas[0].ANO_REF : "",
          Datas: datas
        }, this.handleReferenciaChange);
      }
    }
    catch (e) {
      const err: any = e;
      const Error = err.response ? err.response.data : err;
      this.setState({ Error });
    }
    finally {
      await this.page.current.alternarLoading();
    }
  }

  handleReferenciaChange = async () => {
    try {
      const Referencia = this.state.Referencia;
      if (Referencia) {
        var Informe = await FichaFinanceiraService.BuscarInformePorAno(Referencia);

        this.setState({
          Informe
        });
      }
    }
    catch (e) {
      const err: any = e;
      const Error = err.response ? err.response.data : err;
      this.setState({ Error });
    }
  }

  GerarRelatorio = async () => {
    try {
      const Referencia = this.state.Referencia || this.state.Datas[0].ANO_REF;
      var relatorio = await FichaFinanceiraService.GerarDeclaracaoIR(Referencia, false);

      if (navigator.msSaveBlob) {
        // IE10+ : (has Blob, but not a[download] or URL)
        return navigator.msSaveBlob(new Blob([relatorio]), "Declaração.pdf");
      } else {
        const url = window.URL.createObjectURL(new Blob([relatorio]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Declaração.pdf");
        document.body.appendChild(link);

        link.click();
        URL.revokeObjectURL(url);
      }
    } catch (err) {
      const e: any = err;
      const Error = e.response ? e.response.data : e;
      console.log(Error);
      this.setState({ Error });
    }
  }

  render() {
    return (
      <MasterPage Funcionalidade={NumFuncionalidade.DECLARACAO_IR} {...this.props} ref={this.page}>
        {this.state.Datas.length > 0 &&
          <>
            <Row>
              <Col className={"col-6"}>
                <div className={"mb-3"}>
                  <Combo
                    contexto={this}
                    nome={"Referencia"}
                    valor={this.state.Referencia}
                    titulo={"Calendário"}
                    opcoes={this.state.Datas}
                    onChange={this.handleReferenciaChange}
                    nomeMembro={"ANO_REF"}
                    valorMembro={"ANO_REF"}
                  />
                </div>
              </Col>
            </Row>

            <Row>
              {this.state.Informe.length > 0 && this.state.Informe.map((informe, index) => {
                return (
                  <Col className={"col-6"} key={index}>
                    <Box>
                      <CampoEstatico
                        titulo={"Plano"}
                        valor={informe.Plano.DS_PLANO}
                      />

                      <CampoEstatico
                        titulo={"CNPB"}
                        valor={informe.Plano.COD_CNPB}
                      />

                      <CampoEstatico
                        titulo={"Valor"}
                        valor={informe.Valor}
                        tipo={TipoCampoEstatico.dinheiro}
                      />
                    </Box>
                  </Col>
                );
              })}
            </Row>

            <Row>
              <Col>
                <Botao
                  titulo={"Baixar Declaração"}
                  onClick={this.GerarRelatorio}
                  tipo={TipoBotao.primary}
                  icone={"fas fa-file-download"}
                  className={"mb-4"}
                  usaLoading
                />
              </Col>
            </Row>

            <Row>
              <Col className={"col-6"}>
                <Box titulo={"Informações Importantes"}>
                  <Alerta
                    tipo={TipoAlerta.info}
                    mensagem={`
                  Para o efeito de declaração anual de imposto, o valor supramencionado deve ser somado aos eventualmente constantes no campo
                  "Contribuições a entidades de previdência complementar, pública ou privada, e a fundos de aposentadoria programada individual -
                  FAPI" do Comprovante de Rendimentos fornecido pela Patrocinadora.`}
                  />
                </Box>
              </Col>
            </Row>


            <Alerta
              tipo={TipoAlerta.danger}
              mensagem={this.state.Error}
            />
          </>
        }

        {this.state.Datas.length === 0 &&
          <Alerta
            tipo={TipoAlerta.danger}
            mensagem={"Nenhum informe disponível."}
          />
        }
      </MasterPage>
    );
  };
}
